import { Button } from '@cluey/cluey-components';
import { useEffect } from 'react';
import { generatePath, useHistory } from 'react-router';

import { ReactComponent as CheckIcon } from '../../../assets/images/icon-outline-checked.svg';
import withHeadTag from '../../../common/HeadComponent';
import { ContainerLayout } from '../../../common/hub/ContainerLayout';
import { ShadowContainer } from '../../../components/ShadowContainer/ShadowContainer';
import { scrollToTop } from '../../../util/helpers';
import { PATH_HUB_HOME, PATH_HUB_STUDENT_PROFILE, PATH_HUB_SUPPORT } from '../../../util/pagePath';
import { usePageHeader } from '../../../v2/app-shell/usePageHeader';

type HistoryState = {
  firstName: string;
  studentId: string;
  header?: string;
  message: string;
  headerBackPath?: string;
  headerLabel?: string;
};

const HubContactSuccessPage = () => {
  const history = useHistory<HistoryState>();
  const { firstName, studentId, header, message, headerBackPath, headerLabel } = history.location.state ?? {};
  const { setHeader } = usePageHeader();

  useEffect(() => {
    setHeader({
      label: headerLabel || 'Support',
      showIcon: false,
      showBackButton: true,
      onBackClick: () => history.push(headerBackPath ? headerBackPath : PATH_HUB_SUPPORT),
    });
  }, [headerLabel, headerBackPath, setHeader, history]);

  useEffect(() => {
    scrollToTop();
  }, []);

  const onGoToProfileClick = () => {
    if (studentId) {
      const profilePath = generatePath(PATH_HUB_STUDENT_PROFILE, { studentSfid: studentId });
      history.push(profilePath);
    } else {
      history.push(PATH_HUB_HOME);
    }
  };

  return (
    <ContainerLayout>
      <ShadowContainer className="flex flex-col items-center gap-6 !rounded-3xl bg-white p-6 md:!p-10">
        <div className="flex flex-col items-center gap-2">
          <div className="flex h-[60px] w-[60px] items-center justify-center rounded-full">
            <CheckIcon className="text-white" width={60} height={60} />
          </div>
          <h1 className="font-merriweather text-[32px] font-bold text-grey-600">{header || 'Request submitted'}</h1>
        </div>
        <p className="text-center text-lg text-grey-600">{message}</p>
        <Button
          onClick={onGoToProfileClick}
          size="sm"
          appearance="reverse"
          className="flex h-10 w-auto items-center justify-center !border text-base !font-medium tracking-wide text-grey-400"
        >
          Go {!!studentId ? `to ${firstName}'s profile` : 'Home'}
        </Button>
      </ShadowContainer>
    </ContainerLayout>
  );
};

export default withHeadTag(HubContactSuccessPage);
export { HubContactSuccessPage as StatelessHubContactSuccessPage };
